import axios from '../environments/environments';

const session = sessionStorage.getItem("authorizationGuid");
var sessionHeader = session && session !== undefined && session !== null ? JSON.parse(session) : null;


/**
 * Service to get session header
 *
 * @param { authorizationTokenGuid:string } authorizationTokenGuid
 *
 * @returns { Promise } Promises
 *
 */
const getSessionHeaderData = (authorizationTokenGuid) => {
        try {
            const response = axios.get('security/GetSessionHeader/' + authorizationTokenGuid);
            return response;
        } catch (error) {
            console.log("while getting survey in service:_", error);
        }
}
/**
 * Service to get survey
 *
 * @param { formXmlGuid:string } formXmlGuid
 * @param { dataCollectionGuid:string } dataCollectionGuid
 *
 * @returns { Promise } Promises
 *
 */
const getSurveyData = (formXmlGuid, dataCollectionGuid) => {
    try {
        const response = axios.get('instrument/getinstrument/' + formXmlGuid + '/' + dataCollectionGuid);
        return response;
    } catch (error) {
        console.log("while getting survey in service:_", error);
    }
}

/**
 * Service to get assessment info
 *
 * @param { dataCollectionGuid:string } dataCollectionGuid
 * @param { authorizationTokenGuid:string } authorizationTokenGuid
 *
 * @returns { Promise } Promises
 *
 */
const getAssessmentInfoForDataCollection = (dataCollectionGuid, authorizationTokenGuid) => {
    try {
        const response = axios.get('assessment/GetAssessmentInfoForDataCollection/' + dataCollectionGuid + '/' + authorizationTokenGuid);
        return response;
    } catch (error) {
        console.log("Exceptions:while getting assessment info in service:_", error);
    }
}

/**
 * Service to get assessment info Collections
 *
 * @param { dataCollectionGuid:Array } dataCollectionGuid
 * @param { authorizationTokenGuid:string } authorizationTokenGuid
 *
 * @returns { Promise } Promises
 *
 */
const getAssessmentInfosForDataCollection = (dataCollectionGuid, authorizationTokenGuid) => {
    try {
        const inputParameter = {
            "authorizationGuid": authorizationTokenGuid,
            "dataCollectionGuids": dataCollectionGuid
        }
        const response = axios.post('assessment/GetAssessmentInfosForDataCollection', inputParameter);
        return response;

    } catch (error) {
        console.log("Exceptions:while getting assessment infos data collections in service:_", error);
    }
}

/**
 * Service to put all item response
 *
 * @param { dataCollectionGuid:String } dataCollectionGuid
 * @param { itemResponseSets:Array } itemResponseSets
 * @param { completion:String } completion
 * @param { elapsedTime:Date } elapsedTime
 *
 * @returns { Promise } Promises
 *
 */
const putAllItemResponsesData = (dataCollectionGuid, itemResponseSets, completionStatus, elapsedTime) => {
    try {
        const sessionHeader = sessionStorage.getItem("authorizationGuid");
        var tempItemResponse = [];

        for (const key in itemResponseSets) {
            if (itemResponseSets.hasOwnProperty(key)) {
                const element = itemResponseSets[key];
                tempItemResponse.push(element);
            }
        }

        const requestParameter = {
            "sessionHeader": JSON.parse(sessionHeader),
            "dataCollectionGuid": dataCollectionGuid,
            "completionStatus": completionStatus,
            "itemResponseSets": tempItemResponse,
            "elapsedTimeSegmentSeconds": elapsedTime
        }

        const response = axios.post('response/PutAll', requestParameter);
        return response;

    } catch (error) {
        console.log("Exception:while update the item response in service:_", error);
    }
}

/**
 * Service to put all item response
 *
 * @param { dataCollectionGuid:String } dataCollectionGuid
 * @param { itemResponseSets:Array } itemResponseSets
 * @param { completion:String } completion
 * @param { elapsedTime:Date } elapsedTime
 *
 * @returns { Promise } Promises
 *
 */
const putAllForMultiple = (dataCollectionGuid, itemResponseSets, completionStatus, elapsedTime, putAllForMultipleCollection) => {
    try {
        const sessionHeader = sessionStorage.getItem("authorizationGuid");
        let collections = [];

        for (const key in putAllForMultipleCollection) {
            if (Object.hasOwnProperty.call(putAllForMultipleCollection, key)) {
                const element = putAllForMultipleCollection[key];
                element.completionStatus = completionStatus;
                element.elapsedTimeSegmentSeconds = elapsedTime;
                element.sessionHeader = JSON.parse(sessionHeader);

                var elements = Object.keys(element.itemResponseSetsTemp).map((k) => {
                    return element.itemResponseSetsTemp[k];
                })

                element.itemResponseSets = elements;
                collections.push(element)
            }
        }


        const parameter = {
            "sessionHeader": JSON.parse(sessionHeader),
            "collection": collections
        }

        const response = axios.post('response/putAllForMultiple', parameter);
        return response;

    } catch (error) {
        console.log("Exception:while update the item response in service:_", error);
    }
}

/**
 * Service to get all response
 *
 * @param { dataCollectionGuid:String } dataCollectionGuid
 * @param { sessionHeader:Object } sessionHeader
 *
 */
const getAllResponseData = (dataCollectionGuid, sessionHeader) => {
    try {
        sessionHeader = sessionHeader;
        const requestParameter = {
            "sessionHeader": sessionHeader,
            "dataCollectionGuid": dataCollectionGuid
        }
        const response = axios.post("response/GetAll/", requestParameter);
        response.then(result => {for (const key in result.data) {
            if (result.data.hasOwnProperty(key)) {
                for(let i=0; i < result.data.itemResponseSets.length; i++){
                    for(let j=0; j<result.data.itemResponseSets[i].itemResponses.length; j++) {
                        if(result.data.itemResponseSets[i].itemResponses[j].itemType == 5) {
                            result.data.itemResponseSets[i].itemResponses[j].responseValue = null;
                        }
                    }  
                }
            }
        }});
        return response;
    } catch (error) {
        console.log("Exception:while getting all item responses in the service:_", error);
    }
}

/**
 * Service to get all for multiple response
 *
 * @param { dataCollectionGuid:Array } dataCollectionGuid
 * @param { sessionHeader:Object } sessionHeader
 *
 */
const getAllResponseForMutiple = (dataCollectionGuid, sessionHeader) => {
    try {
        // var sessionHeader = JSON.parse(sessionStorage.getItem("authorizationGuid"));;

        const requestParameter = {
            "sessionHeader": sessionHeader,
            "dataCollectionGuids": dataCollectionGuid
        }
        const response = axios.post("response/getAllForMultiple", requestParameter)
        return response;
    } catch (error) {
        console.log("Exception:while getting all item responses for multiple in the service:_", error);
    }
}


export {
    getSessionHeaderData,
    getSurveyData,
    putAllItemResponsesData,
    putAllForMultiple,
    getAllResponseData,
    getAllResponseForMutiple,
    getAssessmentInfoForDataCollection,
    getAssessmentInfosForDataCollection
}
